import type { FC } from "react";

import { useNotification } from "@react/foundation/notifications";

import { busNotificationApi } from "@apis/bus/api";

import { useJobActions } from "../hooks/useJobActions.ts";

export const JobStatusListener: FC = () => {
  const { updateJob } = useJobActions();

  useNotification("bus:job:status-update", busNotificationApi, ({ job }) => {
    updateJob(job);
  });

  return null;
};
